import React from "react"
import { useEffect } from "react"
import { graphql } from "gatsby"
import { navigate } from "gatsby"
import SEO from "../components/webinar/seo"
import Layout from "../components/webinar/layout"
import moment from "moment-timezone"

const WebinarRegistrationTemplate = ({ pageContext, path, data }) => {
  let webinarDateAndTime = moment(data.strapiWebinar.Testtime).format()
  let webinarDateConverted = moment(data.strapiWebinar.Testtime).format(
    "dddd Do MMMM, YYYY"
  )
  let webinarTimeConverted =
    moment(data.strapiWebinar.Testtime).format("HH:mm") +
    " " +
    moment()
      .tz(moment.tz.guess())
      .format("z")
  let isBefore = moment(webinarDateAndTime).isBefore(moment())
  return (
    <Layout
      Title={data.strapiWebinar.RegistrationTitle}
      BackgroundImage={data.strapiWebinar.BackgroundImage[0].url}
      webinarSubtitle={data.strapiWebinar.Subtitle}
      webinarDate={webinarDateConverted}
      Recording={isBefore}
      displayCalendar={"display:none"}
      formId={data.strapiWebinar.PardotForm}
      formWebinarTime={webinarDateAndTime}
      formWebinarKey={data.strapiWebinar.WebinarKey}
      formPardotProgrammeCode={data.strapiWebinar.PardotProgrammeCode}
      formGuestName={data.strapiWebinar.GuestName}
      webinarTime={webinarTimeConverted}
      guestImage={
        data.strapiWebinar?.GuestofImage?.ImageGuest?.childImageSharp.fluid
      }
      guestTitle={data.strapiWebinar.TitleOfGuest.Title}
      guestParagraph={data.strapiWebinar.GuestParagraph.Paragraph}
      webinarIcons={data.strapiWebinar.SingleIcon}
    >
      <SEO
        title={data.strapiWebinar.RegistrationTitle}
        description={data.strapiWebinar.Subtitle}
      />
    </Layout>
  )
}

export default WebinarRegistrationTemplate

export const query = graphql`
  query WebinarRegistrationTemplate($id: String!) {
    strapiWebinar(id: { eq: $id }) {
      RegistrationTitle
      TitleOfGuest {
        Title
      }
      GuestName
      Testtime
      PardotProgrammeCode
      WebinarKey
      Subtitle
      WebinarDate(formatString: "dddd Do MMMM, YYYY")
      WebinarTime
      GuestParagraph {
        Paragraph
      }
      PardotForm
      # Date {
      #   Date(formatString: "dddd Do MMMM, YYYY")
      #   Time
      # }
      BackgroundImage {
        url
      }
      GuestofImage {
        ImageGuest {
          childImageSharp {
            fluid(maxWidth: 460, quality: 80) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      SingleIcon {
        Image {
          childImageSharp {
            fluid(maxWidth: 80, quality: 80) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        Subtitle
      }
    }
  }
`
